import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import type { ReviewsPageProps } from 'lib/queries/reviews';
import PageWrap from 'components/page-wrap';
import ArticleJson from 'components/structured-data/article';
import HeroRichTitle from 'components/hero-rich-title';
import ArchiveReviews from 'components/archive-reviews';
import ReviewForm from 'components/review-form';
import { getReviewsPage } from 'lib/queries/reviews';

export const getServerSideProps = (async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  );

  return await getReviewsPage(context);
}) satisfies GetServerSideProps<ReviewsPageProps>;

export default function ReviewsPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
) {
  const {
    page: {
      id,
      date,
      seo,
      title,
      modified,
      acf: { hero, pageType },
    },
    reviewsList: { reviews, pagination },
  } = props;

  return (
    <PageWrap seo={seo} pageType={pageType} title={title}>
      <ArticleJson id={id} date={date} modified={modified} seo={seo} />
      <HeroRichTitle {...hero} />
      <ArchiveReviews reviews={reviews} pagination={pagination} />
      <ReviewForm />
    </PageWrap>
  );
}
